<template>
  <div class="c-floating">
    <ul class="floating-wrap">
      <li
        v-if="
          template.meeting.interact_question_icon.display.value &&
            tenantPermInfo.isDisabledVoteQueDown == 2
        "
      >
        <a @click="questionary()">
          <span class="items-text">调查问卷</span>
          <span class="icon icontemp volume"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_vote_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2
        "
      >
        <a @click="getVote()">
          <span class="items-text">投票</span>
          <span class="icon icontemp storied"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_luckdraw_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2
        "
      >
        <a @click="getLuckyDrawRoster()">
          <span class="items-text">幸运抽奖</span>
          <span class="icon icontemp lottery"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_file_icon.display.value &&
            tenantPermInfo.isDisabledVoteQueDown == 2
        "
      >
        <a @click="file()">
          <span class="items-text">文件下载</span>
          <span class="icon icontemp form"></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
import { mixinsTemplate } from "../../common/mixinsTemplate";
export default {
  name: "Suspension",
  mixins: [mixinsTemplate],
  created() {},
  methods: {
    getLuckyDrawRoster() {
      $subscriber.emit("getLuckyDrawRoster");
    },
    getVote() {
      $subscriber.emit("clickOnVote", "shoudong");
    },
    file() {
      $subscriber.emit("showFile");
    },
    questionary() {
      $subscriber.emit("showQuestion", "shoudong");
    }
  }
};
</script>

<style scoped></style>
